// =============================================================================
// src/data/explore-live-config.ts — Configuracao da integracao ao vivo da Explorar.
//
// SRP: centraliza o ENDPOINT externo (regra 9 do CLAUDE.md) num so lugar. Le
//   import.meta.env.VITE_HASURA_URL. DESLIGADO por padrao: sem a env -> enabled=false
//   -> o cliente nunca e criado -> a tela cai no dataset estatico (deploy sem backend
//   e testes/cobertura 100% seguem intactos).
//
// O parametro e um subset tipado de import.meta.env (ImportMetaEnv tem index
//   signature `any`; tipar so o que lemos mantem zero `any` em src/).
// =============================================================================

/** Subset de import.meta.env consumido pela integracao ao vivo. */
export interface ExploreLiveEnv {
  /** Endpoint GraphQL do Hasura (AtalaIA). Vazio/ausente -> integracao desligada. */
  readonly VITE_HASURA_URL?: string;
}

/** Resultado da resolucao: ligar ou nao + o endpoint efetivo. */
export interface ExploreLiveConfig {
  readonly enabled: boolean;
  readonly endpoint: string;
}

/**
 * Resolve a config da integracao ao vivo a partir do ambiente Vite.
 *
 * @example
 *   resolveExploreLiveConfig({ VITE_HASURA_URL: 'http://localhost:8080/v1/graphql' });
 *   // { enabled: true, endpoint: 'http://localhost:8080/v1/graphql' }
 */
export function resolveExploreLiveConfig(env: ExploreLiveEnv): ExploreLiveConfig {
  const endpoint = (env.VITE_HASURA_URL ?? '').trim();
  return { enabled: endpoint.length > 0, endpoint };
}
